<template>
    <div style="display: flex; justify-content: center;" :class="classContent">
        <div class="p-3" :class="classBody" :style="'width:' + width">
            <form class="row align-items-end">
                <div class="col-12 pb-0">
                    <h4 class="text-primary mb-0" style="font-weight: 500;">{{ title }}</h4>
                </div>
                <div class="col-lg-2">
                    <div class="form-group mb-0">
                        <small>Categoría (*)</small>
                        <v-autocomplete
                            v-model="data.category"
                            :items="categories"
                            class="form-control form-control-lg"
                            item-text="code"
                            item-value="code"
                            placeholder="RR"
                            dense
                            outlined
                            hide-details>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group mb-0">
                        <small>Numeración (*)</small>
                        <input v-model="data.number" type="text" class="form-control form-control-lg" @keypress="NUMBER" placeholder="123456789">
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group mb-0">
                        <small>Pais de origen (*)</small>
                        <v-autocomplete
                            v-model="data.country"
                            :items="countries"
                            class="form-control form-control-lg"
                            :item-text="(e) => e.code + ' - ' + e.name"
                            item-value="code"
                            placeholder="GT"
                            dense
                            outlined
                            hide-details>
                        </v-autocomplete>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="form-group mb-0">
                        <button type="button" :disabled="!disabled" @click="onEvent(data)" class="btn btn-primary btn-lg btn-block font-weight-bold">BUSCAR</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
import countries from '@/assets/json/countries.json'
import categories from '@/assets/json/categories.json'
export default {
  props: {
    title: {
      type: String,
      default: 'Seguimiento de envios'
    },
    classContent: {
      type: String,
      default: ''
    },
    classBody: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '80%'
    },
    to: {
      type: String,
      default: 'ClientLocator'
    }
  },
  computed: {
    disabled: function () {
      return this.data ? this.data.category && this.data.number && this.data.country : false
    }
  },
  data () {
    return {
      data: {},
      categories,
      countries
    }
  },
  methods: {
    onEvent: function (data) {
      let guia = data.category + data.number + data.country
      this.data = {}
      this.$router.push({ name: this.to, query: { guia: guia } }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/components/Search.vue